import { Controller } from "@hotwired/stimulus"

// Un <details> que se abre solo cuando la URL apunta a algo que vive dentro
// (/docs/precios#DAT-CORE desde el diccionario): un fragmento hacia un
// elemento dentro de un <details> cerrado no llega a ninguna parte.
export default class extends Controller {
  connect() {
    this.reveal = this.reveal.bind(this)
    window.addEventListener("hashchange", this.reveal)
    this.reveal()
  }

  disconnect() {
    window.removeEventListener("hashchange", this.reveal)
  }

  reveal() {
    const hash = window.location.hash
    if (!hash || hash.length < 2) return
    let target
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)))
    } catch {
      return
    }
    if (!target || !this.element.contains(target)) return
    this.element.open = true
    requestAnimationFrame(() => target.scrollIntoView({ block: "start" }))
  }
}
